import { useState } from "react";
import { BlockView, PageRuntime } from "../blocks/blocks.tsx";
import { Builder } from "../builder/builder.tsx";
import { ApiError } from "../lib/api.ts";
import { proposeAndApply } from "../lib/changes.ts";
import { navigate, useLocation } from "../lib/router.ts";
import { useSession } from "../lib/session.tsx";

export function PageScreen({ name }: { name: string }) {
  const s = useSession();
  const url = useLocation();
  const page = s.pages.find((p) => p.name === name);
  const editing = url.searchParams.get("editar") === "1" && s.canBuild;
  if (!page) return <p className="hint">{s.pages.length ? `A tela "${name}" não existe.` : "Carregando…"}</p>;
  if (editing) return <Builder key={page.version} page={page} />;
  return (
    <PageRuntime collections={s.collections} workflows={s.workflows}>
      <div className="topbar">
        <h1>{page.title}</h1>
        <span className="spacer" />
        {s.canBuild && (
          <button className="btn" onClick={() => navigate(`/t/${page.name}?editar=1`)}>
            Editar tela
          </button>
        )}
      </div>
      <div className="grid">
        {page.blocks.map((b) => (
          <div key={b.id} className={`blk card ${b.width}`}>
            <BlockView block={b} />
          </div>
        ))}
        {!page.blocks.length && <div className="empty">Tela vazia. {s.canBuild ? "Clique em Editar tela para adicionar blocos." : ""}</div>}
      </div>
    </PageRuntime>
  );
}

const machine = (s: string) =>
  s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .replace(/^(\d)/, "t_$1")
    .slice(0, 40);

export function NewPage() {
  const s = useSession();
  const [title, setTitle] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  if (!s.canBuild) return <p className="hint">Só donos e construtores criam telas.</p>;

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const name = machine(title);
    if (!name) return setErr("Dê um nome à tela.");
    setBusy(true);
    try {
      await proposeAndApply(`Criar a tela ${title}`, [{ op: "page.create", name, title, menu: true }]);
      await s.reloadStructure();
      navigate(`/t/${name}?editar=1`);
    } catch (e) {
      setErr(e instanceof ApiError ? (e.details[0]?.message ?? e.message) : "Não foi possível criar a tela.");
      setBusy(false);
    }
  }

  return (
    <div style={{ maxWidth: 460 }}>
      <div className="topbar">
        <h1>Nova tela</h1>
      </div>
      <form className="card stack" onSubmit={submit}>
        <label className="fld">
          Título
          <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Ex.: Pedidos" required />
          {title && <span>Nome interno: {machine(title) || "—"}</span>}
        </label>
        {err && <p className="error" style={{ margin: 0 }}>{err}</p>}
        <div>
          <button className="btn primary" disabled={busy}>
            Criar e editar
          </button>
        </div>
      </form>
    </div>
  );
}
